function check_touch_enabled() {
  return !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
}
var has_observer = new MutationObserver((function (e) {
  e.forEach((function (e) {
    e.addedNodes.forEach((function (e) {
      if (e.className && e.className.startsWith("swatch-single")) {
        var t = 0;
        $(".swatch-single").each((function () {
          t++;
          var e = $(this),
            o = e.find(".swatch-option-name");
          e.has(".option_number").length <= 0 && (e.attr("data-num", t), o.length ? (o.prepend(`<div class="option_number">${t}</div>`), o.prepend(
            `<span class="selected_tick hidden" data-num="${t}"></span>`)) : ((o = e.find(".swatch-label")).prepend(`<div class="option_number">${t}</div>`), o.prepend(
            `<span class="selected_tick hidden" data-num="${t}"></span>`)))
        }))
      }
    }))
  }))
}));
if (void 0 !== window.hulkapps) {
  var els_to_observe = document.getElementById("product_form_" + window.hulkapps.product_id);
  els_to_observe && has_observer.observe(els_to_observe, {
    attributes: !1,
    childList: !0,
    subtree: !0
  })
}
var ha_observer = new MutationObserver((function (e) {
    e.forEach((function (e) {
      e.addedNodes.forEach((function (e) {
        if (e.id == "hulkapps_options_" + window.hulkapps.product_id) {
          var t = $(".product-form .swatch-single").length;
          $(".hulkapps_option").each((function () {
            t++, $(this).find(".hulkapps_option_name").prepend(`<div class="option_number">${t}</div>`), $(this).find(".hulkapps_option_name").prepend(
              '<span class="selected_tick hidden"></span>')
          }))
        }
      }))
    }))
  })),
  el_to_observe = document.getElementById("hulkapps_custom_options_" + window.hulkapps.product_id);
el_to_observe && ha_observer.observe(el_to_observe, {
  childList: !0
}), $(document).ready((function (e) {
  e(".product-form__variants").attr("style", "display: block !important"), e(
    '.product-form__option, form[action="/cart/add"] .product__variants, form[action="/cart/add"] .form__row div.selector-wrapper, form .swatch.clearfix').attr("style",
    "display: none !important")
})), $(document).on("submit", ".product-form", (function (e) {
  var t = !0;
  $(".product-form .hulkapps_option").each((function () {
    0 == $(this).hasClass("is_selected") && ($(this).addClass("validation_error"), t = !1)
  })), $(".product-form .swatch-single").each((function () {
    0 == $(this).hasClass("is_selected") && ($(this).addClass("validation_error"), t = !1)
  })), t || e.preventDefault()
})), $(document).ready((function () {
  $(document).find("#itg-new-search").find(".search-bar__submit").on("click", (function (e) {
    e.preventDefault();
    var t = $(document).find("#itg-new-search").find(".itg-new-search-input-field").val();
    if ("" == t) $(document).find(".itg-search-reset").click();
    else {
      var o = $(document).find("#itg-new-search").find(".itg-new-search-input-field").data("collection"),
        n = "/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=show&q=" + t;
      $(document).find(".collection-wrapper").addClass("loading"), $.ajax({
        url: n,
        type: "GET",
        dataType: "html",
        success: function (e) {
          $(e).find(".itg-data-count").data("count");
          var n = "",
            i = 0,
            r = 0;
          $(e).find(".product-item").each((function () {
            var e = $(this).data("collections").split(","),
              t = 0;
            $.each(e, (function (e, n) {
              n === o && (t = 1)
            })), 1 === t && (n += '<div class="product-item product-item--vertical  1/3--tablet-and-up 1/4--desk">', n += $(this).html(), n += "</div>", i = 1, r += 1)
          })), $(document).find(".itg-search-query").text(t), $(document).find(".itg-search-showing-count").text("Showing " + r + " - " + r + " of " + r + " product"), 1 == i ? $(
            document).find(".itg-show-collection").find(".product-list").html(n) : $(document).find(".itg-show-collection").find(".product-list").html("No result Found"), $(
            document).find(".itg-show-collection").show(), $(document).find(".itg-hide-collection").hide(), $(document).find(".collection-wrapper").removeClass("loading"), $(
            document).find(".itg-search-reset").removeClass("disabled")
        },
        error: function (e, t) {
          location.reload()
        }
      })
    }
  })), $(document).find("#itg-new-search").find(".itg-new-search-input-field").on("keydown", (function (e) {
    if (13 === (e.keyCode ? e.keyCode : e.which)) {
      e.preventDefault();
      var t = $(this).val();
      if ("" == t) $(document).find(".itg-search-reset").click();
      else {
        var o = $("input.itg-new-search-input-field.is-filled").attr("data-collection"),
          n = "/collections/" + o + "/Brand_" + t;
        $(document).find(".collection-wrapper").addClass("loading"), $.ajax({
          url: n,
          type: "GET",
          dataType: "html",
          success: function (e) {
            $(e).find(".itg-data-count").data("count");
            var n = "",
              i = 0,
              r = 0;
            $(e).find(".product-item").each((function () {
                var e = $("input.itg-new-search-input-field.is-filled").attr("data-collection").split(","),
                  t = 0;
                $.each(e, (function (e, n) {
                  n === o && (t = 1)
                })), 1 === t && (n += '<div class="product-item product-item--vertical  1/3--tablet-and-up 1/4--desk">', n += $(this).html(), n += "</div>", i = 1, r += 1)
              })), $(document).find(".itg-search-query").text(t), $(document).find(".itg-search-showing-count").text("Showing " + r + " - " + r + " of " + r + " product"), 1 == i ?
              $(document).find(".itg-show-collection").find(".product-list").html(n) : $(document).find(".itg-show-collection").find(".product-list").html(
                '<div class="not-found">No result Found</div>'), $(document).find(".itg-show-collection").show(), $(document).find(".itg-hide-collection").hide(), $(document).find(
                ".collection-wrapper").removeClass("loading"), $(document).find(".itg-search-reset").removeClass("disabled")
          },
          error: function (e, t) {
            location.reload()
          }
        })
      }
    }
  })), $(document).find(".itg-search-reset").on("click", (function (e) {
    e.preventDefault(), $(this).hasClass("disabled") || ($(document).find(".itg-new-search-input-field").val(""), $(document).find(".itg-hide-collection").show(), $(document).find(
      ".itg-show-collection").hide(), $(this).addClass("disabled"))
  }))
})), $(document).ready((function () {
  $(document).on("change", "#faster-checkbox", (function () {
    $(this).is(":checked") ? $(document).find(".shopify-payment-button__button").attr("disabled", !0) : $(document).find(".shopify-payment-button__button").attr("disabled", !1)
  }))
})), (() => {
  const e = document.querySelector("select.maincategory") ?.selectedOptions[0].dataset.handle;
  document.querySelectorAll("select.subcategory").forEach((t => {
    const o = t.dataset.value;
    e == o ? t.classList.remove("itg-hide") : t.classList.add("itg-hide")
  }))
})(), (() => {
  const e = document.getElementById("header-newsletter-toggle"),
    t = document.querySelector(".announcement-bar__close");
  e.addEventListener("click", (e => {
    const t = document.getElementById("announcement-bar-newsletter");
    "true" == t.ariaHidden && (t.style.height = "auto", t.ariaHidden = !1)
  })), null !== t && t.addEventListener("click", (e => {
    const t = document.getElementById("announcement-bar-newsletter");
    t.style.height = 0, t.ariaHidden = !0
  }))
})(), window.addEventListener("theme:search:done", (e => {
  document.querySelectorAll(".search-results__qty-button").forEach((e => {
    e.addEventListener("click", (() => {
      const t = e.parentNode.querySelector(".search-results__qty-amount");
      e.classList.contains("qty-plus") ? t.value = parseInt(t.value) + 1 : parseInt(t.value) > 1 && (t.value = parseInt(t.value) - 1)
    }))
  }))
})), window.addEventListener("load", (() => {
  const e = document.querySelectorAll(".CB-featuredProducts .starReview"),
    t = Array.from(e);
  null != t & null != e && t.forEach((e => {
    const t = e.querySelectorAll(".yotpo-sr-bottom-line-text")[0] ?.innerHTML,
      o = t ?.replace(/\D/g, "");
    "0" !== o && e.classList.replace("hideStarReview", "showStarReview")
  }))
}));
var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

function closemodal() {
  jQuery("#reorderpopup").hide()
}
screenWidth < "770" && $(".product-intro .product-meta .title h1").each((function () {
  $(this).replaceWith("<h2>" + $(this).html() + "</h2>")
})), screenWidth >= "770" && $(".product-intro .protitle_resp.title h1").each((function () {
  $(this).replaceWith("<h2>" + $(this).html() + "</h2>")
})), $(document).on("change", "input[type=number]", (function (e) {
  var t = $(this).val(),
    o = $(this);
  if (0 == t) o.val(1);
  else {
    var n = t.split(".")[0];
    $(this).val(n)
  }
})), jQuery("#reorderpopup").hide(), jQuery(".reorder-btn-popup").on("click", (function () {
  var e = "";
  $(".modal-body").text(e);
  for (var t = $(this), o = t.attr("data-order-id"), n = t.attr("data-order-totalprice"), i = t.attr("data-order-name"), r = [], a = 0; a < orderData[o].length; a++) e = $(
    '<div class="itemdetails " data-variant-id="' + orderData[o][a].id + '" data-quantity="' + orderData[o][a].quantities +
    '"> <div class="col-12 reorderitem card p-3" style=""><div class="card-wrap"><div class="row card-wrap-inner align-items-center"><div class="col-sm-4"><div class="d-flex align-items-center"><div class="reordrbtn-wrap"><input type="checkbox" id="removeitem_' +
    orderData[o][a].id + '" checked name="removeitem_" value="' + orderData[o][a].id + '"><label for="removeitem_' + orderData[o][a].id +
    '">&nbsp;</label></div><div class="product_img_main"><img style="width:100px;" src="' + orderData[o][a].image +
    '" class="card-img-top" alt=""></div><div class="quty d-flex"><input type="number" min="1" value="' + orderData[o][a].quantities +
    '"><span style="font-weight:600;"> x </span></div></div></div><div class="col-sm-8"><div class="card-body"><h5 class="card-title">' + orderData[o][a].title +
    '</h5><p class="card-text reorderitem_price">' + orderData[o][a].price + ' USD</p><p class="card-text"></p></div></div></div></div></div></div>'), $(".modal-title").text(
    "Summary Order (" + i + ") -" + n), $(".modal-body").append(e), r.push({
    id: orderData[o][a].id,
    quantity: orderData[o][a].quantities,
    title: orderData[o][a].title,
    price: orderData[o][a].price,
    image: orderData[o][a].image
  });
  jQuery("#reorderpopup").show()
})), jQuery(".addtocart_reorder, .addtocart_reordercheckout").on("click", (function () {
  var e = $(this).attr("id"),
    t = [];
  $(".itemdetails").each((function () {
    var e = $(this),
      o = e.find("input[type=number]").val(),
      n = e.attr("data-variant-id");
    e.find("input[type=checkbox]").each((function () {
      this.checked && t.push({
        id: n,
        quantity: o
      })
    }))
  }));
  let o = {
    items: t
  };
  var n, i;
  i = "", "reorder_only" == (n = e) ? (i = "/cart", $.ajax({
    url: "/cart/add.js",
    method: "POST",
    data: o,
    beforeSend: function () {
      $("#reorder_only").prop("disabled", !0)
    },
    success: function (e) {
      $("#reorder_only").prop("disabled", !1), window.location.href = i
    },
    error: function (e) {
      console.error("Error adding product to cart:"), window.location.href = "/account"
    }
  })) : "reorder_checkout" == n && (i = "/checkout", Shopify.clear((function () {
    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      data: o,
      beforeSend: function () {
        $("#reorder_checkout").prop("disabled", !0), $("#reorder_checkout").text("Checking Out..")
      },
      success: function (e) {
        $("#reorder_checkout").prop("disabled", !1), $("#reorder_checkout").text("Reorder & Checkout"), window.location.href = i
      },
      error: function (e) {
        console.error("Error adding product to cart:"), window.location.href = "/account"
      }
    })
  })))
}));
  
window.addEventListener('load', function() {
    var _learnq = window._learnq || [];
    function addedToCart() {
      fetch(`${window.location.origin}/cart.js`)
      .then(res => res.clone().json().then(data => {
        var cart = {
          total_price: data.total_price/100,
          $value: data.total_price/100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price/100,
          items: data.items
        }
        if (typeof item !== 'undefined') {
          cart = Object.assign(cart, item)
        }
        if (klAjax) {
            _learnq.push(['track', 'Added to Cart', cart]);
            klAjax = false;
          }
      }))
    };
    (function (ns, fetch) {
      ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
          if (`${window.location.origin}/cart/add.js`
            .includes(res.url)) {
              addedToCart()
          }
        });
        return response
      }
    }(window, window.fetch));
    var klAjax = true;
    var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
    for (var i = 0; i < atcButtons.length; i++) {
        atcButtons[i].addEventListener("click", function(event) {
          if (klAjax) {
            // Also record quick add to cart to Klaviyo
            if ( typeof item === 'undefined') {
              var quickItem = JSON.parse(event.target.closest('form').dataset.klaviyo);
              _learnq.push(['track', 'Added to Cart', quickItem]);
            }
  
            if ( typeof item !== 'undefined') {
              _learnq.push(['track', 'Added to Cart', item]);
            }
            klAjax = false;
          }
        })
    }
    });

$(document).ready(function(){
  $('.accordian-section').each(function(index, element){
      $(this).attr('data-id',index);
  });
  $("[data-id='0'] .accordion-list.container .accordian-listss").addClass('active'); 

  $('body').on('click', '.accordian-section', function() {  
    let dataId = $(this).attr("data-id");
    $(".accordion-list.container .accordian-listss").removeClass('active'); 
    $("[data-id='" + dataId + "'] .accordion-list.container > .accordian-listss").addClass('active');  
      let topPosition = $("[data-id='" + dataId + "'] .accordion-list.container > .accordian-listss").offset().top;  
      window.scrollTo({ top: topPosition, behavior: "smooth" }); 
    });
});